import { Alert, AlertTitle, Box, Button, Container, Divider, Grid, Paper, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import UserContext from "../../../navigation/context/userContext";

import PhotoSizeSelectLargeIcon from '@mui/icons-material/PhotoSizeSelectLarge';
//import { UpdateImagen } from "../../../controllers/company/CompanyProfileController";
import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { imagesURL } from "../../../apiRoutes/apiBase";
import { GetImagenes } from "../../../controllers/company/CompanyProfileController";
import { Dropzone, FileMosaic, FullScreen, ImagePreview } from "@files-ui/react";


export default function CompanyProfileImages()
{
    const {userData, setUserData} = useContext(UserContext);

    const [logoUrl,setLogoUrl] = useState('');
    const [logoFile,setLogoFile] = useState([]);

    const [coverUrl,setCoverUrl] = useState('');
    const [coverFile,setCoverFile] = useState([]);

    const [imgPreviewSrc, setImgPreviewSrc] = useState(undefined);


    const [rutaImgFondo,setRutaImgFondo] = useState('');
    const [imgFondo,setImgFondo] = useState([]);

    const [rutaImgRecuadro,setRutaImgRecuadro] = useState('');
    const [imgRecuadro,setImgRecuadro] = useState([]);

    const [message,setMessage] = useState('');
    const [showAlert,setShowAlert] = useState(false);

    useEffect(()=>{
        getImagenes();
    },[]);


    const handleSee = (imageSource) => {
        setImgPreviewSrc(imageSource);
    };


    const updateLogoFile = async (incommingFiles) => {
        //do something with the files
        setLogoFile(incommingFiles);

        //even your own upload implementation        
        UpdateImagen('imagenRecuadro',incommingFiles[0].file);
    };
    const removeLogoFile = (id) => {
        setLogoFile(logoFile.filter((x) => x.id !== id));
    };


    const updateCoverFile = async (incommingFiles) => {
        //do something with the files
        setCoverFile(incommingFiles);

        //even your own upload implementation        
        UpdateImagen('imagenFondo',incommingFiles[0].file);
    };
    const removeCoverFile = (id) => {
        setCoverFile(logoFile.filter((x) => x.id !== id));
    };





    const UpdateImagen = async (variable,valor) =>
    {
        console.log('Cambiando las imagenes')
        var token = 'Bearer '+ userData.token;
    
          var data = new FormData();
          //data.append('imagenFondo',this.state.imagenFondo);          
          data.append(variable,valor);
    
          try 
          {
                let response = await fetch(
                    CompanyRoutes.Profile.UpdatePicture,
                    {
                        method : 'POST',
                        headers :
                        {
                            'Accept' : 'application/json',
                            //'Content-Type' : 'multipart/form-data; boundary=<calculated when request is sent>',
                            'Authorization' : token,
                        },
                        body : data
                    }
                );
              
                let responseJson = await response.json();          
                
                if(responseJson.success === true)
                {    
                    setShowAlert(true);
                    setMessage(responseJson.message);
                    await setTimeout( () => 
                        setShowAlert(false),7000
                    );
                }
              
          } 
          catch (error) 
          {
              this.setState({progres:false});
              alert(error)
          }
    }

    const getImagenes = async () => {
        let response = await GetImagenes();
        if(response.success === true)
        {
            if(response.data.imgFondo !== null)
            setCoverUrl(imagesURL + 'empresas/'+response.data.imgFondo);

            if(response.data.imgRecuadro !== null)
            setLogoUrl(imagesURL + 'empresas/'+response.data.imgRecuadro);
        }
    }


    return(
        <Paper elevation={4}>
            <Grid container spacing={3}>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Typography variant="h6" fontWeight={'bold'}>Logo</Typography>
                    <Typography variant="body1">Se recomienda una imagen cuadrada ejemplo 512x512 px</Typography>

                    {/**Imagen de perfil */}
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Dropzone
                            onChange={updateLogoFile}
                            label="Imagen de perfil"
                            value={logoFile}
                            accept="image/*"
                            maxFileSize={512 * 1024}
                            maxFiles={1}
                            behaviour="replace"
                            cleanFiles
                            actionButtons={{ position: "bottom", cleanButton: {} }}
                            localization="ES-es"
                        >
                            {
                                logoFile.length > 0 
                                ?
                                    logoFile.map((file) => (
                                        <FileMosaic
                                            key={file.id}
                                            {...file}
                                            onSee={handleSee}
                                            onDelete={removeLogoFile}
                                            info
                                            preview
                                            smartImgFit="center"
                                        />
                                    ))
                                :
                                    <Box sx={{width:{xs:150,sm:200,md:200,lg:250,xl:250}, height:{xs:150,sm:200,md:200,lg:250,xl:250},p:2}}>
                                        <img style={{width:'100%',height:'100%'}} src={logoUrl} alt={'QUD'}/>
                                    </Box>
                            }
                        </Dropzone>
                    </Grid>
                </Grid>
                
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Typography variant="h6" fontWeight={'bold'}>Foto de portada</Typography>
                    <Typography variant="body1">Se recomienda una imagen rectangular ejemplo 800 x 866 px</Typography>
                    {/**Imagen de portada */}
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Dropzone
                            onChange={updateCoverFile}
                            label="Imagen de portada"
                            value={coverFile}
                            accept="image/*"
                            maxFileSize={512 * 1024}
                            maxFiles={1}
                            behaviour="replace"
                            cleanFiles
                            actionButtons={{ position: "bottom", cleanButton: {} }}
                            localization="ES-es"
                        >
                            {
                                coverFile.length > 0 
                                ?
                                    coverFile.map((file) => (
                                        <FileMosaic
                                            key={file.id}
                                            {...file}
                                            onSee={handleSee}
                                            onDelete={removeCoverFile}
                                            info
                                            preview
                                            smartImgFit="center"
                                        />
                                    ))
                                :
                                    <Box 
                                        sx={{
                                            width: { xs: 240, sm: 200, md: 200, lg: 250, xl: 400 },
                                            height: { xs: 260, sm: 217, md: 217, lg: 271, xl: 433 },
                                            p:2
                                        }}
                                    >
                                        <img style={{width:'100%',height:'100%'}} src={coverUrl} alt={'QUD'}/>
                                    </Box>
                            }
                        </Dropzone>
                    </Grid>
                </Grid>

                <FullScreen
                    open={imgPreviewSrc !== undefined}
                    onClose={() => setImgPreviewSrc(undefined)}
                >
                    <ImagePreview src={imgPreviewSrc} />
                </FullScreen>
            </Grid>
        </Paper>
        
    )
}